import { render } from "./DetailedSecView.vue?vue&type=template&id=563f79b4&scoped=true"
import script from "./DetailedSecView.vue?vue&type=script&lang=js"
export * from "./DetailedSecView.vue?vue&type=script&lang=js"

import "./DetailedSecView.vue?vue&type=style&index=0&id=563f79b4&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563f79b4"]])

export default __exports__